// eslint-disable-next-line import/prefer-default-export
export function convertToLargerPossibleUnit(bytes: number): string {
  return `${(bytes / 1000).toFixed(1)} kb`;
}
